/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import {is_visible_in_view} from "../helpers/functions";
import axios from "axios";
import Swiper from './../libs/swiper';

$(function(){

    new Swiper('#posts-swiper', {
        navigation: {
            nextEl: '#other-post-next',
            prevEl: '#other-post-prev'
        },
        spaceBetween: 50,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            }
        }
    });

    function initArticleEvents(){
        let $section = $('.section-blog-article');
        if(!$section.length){
            return;
        }

        $section.find('.lead-aside form').on('submitted', function(){
            $(window).trigger("headerSpacer.resized");
        });
    }

    initArticleEvents();

    // Related
    function initRelatedScrollEvents() {
        let $sectionHow = $('.section-blog-article');
        if(!$sectionHow.length){
            return;
        }

        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        if(is_visible_in_view($sectionHow, 'any') && $section.data('reload')){
            $section.data('reload', 0);

            initRelatedAjaxEvents();
        }
    }

    function initRelatedEvents() {
        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        $('.section-offer-related').addClass('is-loading').data('reload', 1);

        $(window).scroll(function () {
            initRelatedScrollEvents();
        });
        initRelatedScrollEvents();
    }

    initRelatedEvents();

    let $relatedRequest = null;
    function initRelatedAjaxEvents(){
        let $visitor_id;
        if(typeof _paq !== 'undefined'){
            _paq.push([ function() { $visitor_id = this.getVisitorId(); }]);
        }

        $relatedRequest = axios.CancelToken.source();

        axios.get('/model/related', {params: {visitor_id: $visitor_id}, cancelToken: $relatedRequest.token})
            .then(function(response){
                let $html = $(response.data.page.html);
                let $htmlRelated = $html.filter('.section-offer-related').find(' .swiper-outer-container');

                let $containerRelated = $('.section-offer-related');

                $containerRelated.find('.swiper-outer-container').remove();
                $htmlRelated.insertAfter($containerRelated.find('.not-found'));

                $containerRelated.removeClass('is-loading').data('reload', 0);

                initRelatedSwiperEvents();
            })
            .catch(function(){

            });
    }

    function initRelatedSwiperEvents(){
        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        new Swiper('.section-offer-related .offer-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -60,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                }
            }
        });
    }
});
